import { useState } from "react";
import Header from "./Header";

function Notification() {
  const templates = [
    {
      title: "💖 New Match Alert!",
      message:
        "We found someone who perfectly matches your preferences. Check now!",
    },
    {
      title: "✨ Someone Liked Your Profile",
      message:
        "A new interest request just arrived. Open Gorishtey to respond!",
    },
    {
      title: "😍 A Potential Partner Awaits",
      message: "Your daily curated matches are ready. Explore now!",
    },
    {
      title: "🔔 Your Profile Is Getting Attention",
      message: "Someone viewed your profile recently. See who it was!",
    },
    {
      title: "❤️ Handpicked Match Just for You",
      message: "A highly compatible match has joined. Don’t miss out!",
    },
    {
      title: "💌 You’ve Got a Connection Request",
      message: "Someone wants to connect with you on Gorishtey. Check now!",
    },
    {
      title: "🎉 Fresh Profiles Added Today",
      message: "New members joined Gorishtey. Find your perfect match!",
    },
    {
      title: "📩 Your Matches Are Waiting",
      message:
        "Open Gorishtey to view your new personalized match recommendations!",
    },
    {
      title: "🔥 Don’t Miss Today’s Best Profiles",
      message: "Swipe through today’s most compatible matches!",
    },
    {
      title: "💍 Take the Next Step Today",
      message: "Your dream partner could be just one tap away. Explore now!",
    },
    {
      title: "🌟 Someone Special Noticed You",
      message: "A member is showing interest—reply and continue the journey!",
    },
    {
      title: "🥰 It's a Perfect Time to Connect",
      message: "Login now and find someone who matches your vibe!",
    },
    {
      title: "🎧 Unlock Audio Calls Today",
      message:
        "Talk directly with your matches! Upgrade now and start meaningful conversations.",
    },
    {
      title: "🎥 Want to See Your Match Live?",
      message:
        "Video calling is available for premium members. Upgrade to connect face-to-face!",
    },
    {
      title: "📞 Get Contact Details Instantly",
      message:
        "Unlock phone numbers & WhatsApp details of your matches with a premium upgrade.",
    },
    {
      title: "⚡ Premium Matchmaking Awaits",
      message:
        "Access audio calls, video calls & direct contact sharing. Upgrade now!",
    },
    {
      title: "❤️ Talk Freely With Your Match",
      message: "Upgrade to premium and start audio/video calls without limits!",
    },
    {
      title: "💬 Your Match Wants to Talk!",
      message: "Upgrade now to unlock calling features and connect instantly.",
    },
    {
      title: "💛 Don't Just Match… Connect!",
      message:
        "Get full access to contact information and start real conversations.",
    },
    {
      title: "🔓 Contact Unlock Available",
      message:
        "View your match’s phone number and reach out directly—upgrade now.",
    },
    {
      title: "📱 Make Your First Call",
      message:
        "Premium enables calling & direct contact sharing. Take the next step today!",
    },
    {
      title: "🎊 Premium Benefits Just for You",
      message:
        "Enjoy video calls, audio calls, priority visibility & more. Upgrade now!",
    },
    {
      title: "🌟 Your Match Is Waiting",
      message: "Upgrade to connect faster with audio/video calling features.",
    },
    {
      title: "🤝 Build a Real Connection",
      message:
        "Unlock contact details and start talking with your perfect match today.",
    },
  ];

  const [formData, setFormData] = useState({
    title: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendNotification = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/SendNotificationToAll",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            title: formData.title,
            message: formData.message,
          }),
        }
      );

      if (!response.ok) throw new Error("Failed to send notification");

      alert("Notification sent successfully!");
      setFormData({ title: "", message: "" });
    } catch (error) {
      console.error("Error:", error);
      alert("Error sending notification");
    }
  };

  return (
    <>
      <Header />
      <div className="container py-3">
        <h3 className="m-0 lh-sm">Send Push Notification</h3>
        <p className="mb-5 text-danger">
          ⚠️ Once sent, notifications cannot be undone. Please review before
          submitting.
        </p>

        <form
          onSubmit={handleSendNotification}
          className="col-lg-6 col-12 row g-2 bg-light p-4 rounded-4"
        >
          <div className="col-12">
            <label className="form-label mb-1 mt-0">Notification Title</label>
            <input
              type="text"
              name="title"
              placeholder="Enter Title"
              className="form-control rounded-4"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-12">
            <label className="form-label mb-1 mt-0">
              Notification Description
            </label>
            <textarea
              type="text"
              name="message"
              placeholder="Enter Description"
              className="form-control rounded-4"
              value={formData.message}
              onChange={handleChange}
              required
              rows="3"
            ></textarea>
          </div>
          <div className="col-12">
            <button
              type="submit"
              className="btn btn-primary rounded-pill mt-2 px-5"
            >
              Send Notification
            </button>
          </div>
        </form>

        <div className="mb-4 mt-4">
          <h3 className="m-0 lh-sm mb-4">Select a Template / Enter Manually</h3>

          <div className="row g-2">
            {templates.map((item, index) => (
              <div className="col-md-4" key={index}>
                <button
                  type="button"
                  onClick={() => setFormData(item)}
                  className="btn btn-outline-light bg-success-soft w-100 text-start p-4 rounded-4 h-100"
                >
                  <h4 className="fw-semibold lh-1">{item.title}</h4>
                  <p className="m-0 text-danger opacity-75 fw-normal lh-1">
                    {item.message}
                  </p>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Notification;
